<button type="button" class="scan-compare-selected" *ngIf="selection.selected.length > 1" (click)="compareOrders()">Compare selected</button>

<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<div class="scan-grid" [formGroup]="formGroup" *ngIf="!loading" formArrayName="orders">
	<app-form-order-image
		*ngFor="let order of ordersFormArray.controls; let i = index"
		[order]="ordersFormArray.controls[i]"
		[withDelete]="true"
		[(selection)]="selection"
		[index]="i"
		(clickDelete)="deleteOrder($event)"
		(clickReturn)="returnOrder($event)"
		(clickExchange)="exchangeOrder($event)"
		(clickEmail)="emailOrder($event)"
		(clickSetAsPrescription)="setOrderAsPrescription($event)">
	</app-form-order-image>
</div>
